import { DocumentNode, gql } from "@apollo/client";

const GET_MENU = () => {
    return gql`
        query Menu {
            result: menus {
                enabled
                link {
                    uri
                    url {
                        path
                        routed
                    }
                }
                title
            }
        }
    `;
};

export const GET_ALL_MENU_PARAMS = (): {
    query: DocumentNode;
    options: {
        skip: boolean;
    };
} => {
    return {
        query: GET_MENU(),
        options: {
            skip: false
        }
    };
};
